import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../ui/cn';

export const ChoiceCard: React.FC<{
  title: string;
  description?: string;
  selected: boolean;
  onSelect: () => void;
  children?: React.ReactNode;
  disabled?: boolean;
  tickPlacement?: 'top-right' | 'bottom-right';
}> = ({
  title,
  description,
  selected,
  onSelect,
  children,
  disabled,
  tickPlacement = 'bottom-right',
}) => (
  <button
    type="button"
    role="radio"
    aria-checked={selected}
    aria-label={title}
    disabled={disabled}
    onClick={onSelect}
    className={cn(
      'door-designer-choice relative flex w-full flex-col rounded-xl border border-solid bg-card p-4 text-left shadow-xs transition-colors',
      selected ? 'border-primary ring-1 ring-primary' : 'border-border hover:bg-muted/50',
      disabled && 'cursor-not-allowed opacity-60'
    )}
  >
    {selected ? (
      <span
        className={cn(
          'absolute flex h-5 w-5 items-center justify-center rounded-full bg-primary text-primary-foreground',
          tickPlacement === 'top-right' ? 'top-3 right-3' : 'bottom-3 right-3'
        )}
      >
        <Check className="h-3 w-3" />
      </span>
    ) : null}
    {children}
    <span
      className={cn(
        'flex min-w-0 flex-col',
        children ? 'mt-3' : undefined,
        tickPlacement === 'bottom-right' ? 'pr-8' : undefined
      )}
    >
      <span className="text-sm font-semibold">{title}</span>
      {description ? (
        <span className="mt-1 text-sm text-muted-foreground">{description}</span>
      ) : null}
    </span>
  </button>
);
